import {
  Box,
  Button,
  FormGroup,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Tooltip,
} from "@mui/material";
import React, { useMemo, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { EditOutlined, Info, MoreHoriz } from "@mui/icons-material";
import { useGlobalFilter, useSortBy, useTable } from "react-table";
import { GlobalFilter } from "../../components/GlobalFilter/GlobalFilter";
import { useLists } from "../../context/listContext";
import { AntSwitch } from "../../styles/index.sty";
import { toggleOrderData, updateOrderStatus } from "../../api/orders.api";
import { useAuth } from "../../context/authContext";
import PuffLoader from "react-spinners/PuffLoader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "45rem",
  bgcolor: "white",
  // border: "2px solid #000",
  borderRadius: "25px",
  boxShadow: 24,
  p: 2,
  padding: "2rem",
};

const spinnerstyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

export const Orders = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  const [ filteredList, setFilteredList ] = useState([]);
  const [filterStatus, setFilterStatus] = useState("All");
  const [order, setOrder] = useState({});
  const [order_status, setOrderStatus] = useState("");
  const { config } = useAuth();
  const { ordersList, fetchOrdersList } = useLists();
  const data = useMemo(() => filteredList, [filteredList]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrdersList();
  }, []);
  useEffect(() => {
    setFilteredList(ordersList);
  }, [ordersList])
  useEffect(() => {
    if (ordersList.length > 0) {
      setLoading(false);
    }
  }, [ordersList]);
  const statusList = [
    {
      label: "Pending",
      value: "Pending",
    },
    {
      label: "Payment Pending",
      value: "Payment Pending",
    },
    {
      label: "Accepted",
      value: "Accepted",
    },
    {
      label: "In-Progress",
      value: "In-Progress",
    },
    {
      label: "Delivered",
      value: "Delivered",
    },
  ];
  const columns = useMemo(
    () => [
      {
        Header: "Status",
        accessor: "order_status",
      },
      {
        Header: "Subtotal",
        accessor: "order_subtotal",
      },
      {
        Header: "Payment Method",
        accessor: "payment_method",
      },
    ],
    []
  );

  const tableHooks = (hooks) => {
    hooks.visibleColumns.push((columns) => [
      {
        id: "Order Id",
        Header: "Order Id",
        Cell: ({ row }) => <p>...{row?.original?.order_id?.slice(-8)}</p>,
      },
      {
        id: "User Name",
        Header: "User Name",
        Cell: ({ row }) => (
          <p>
            {`${row?.original?.user?.first_name} ${row?.original?.user?.last_name}`}
          </p>
        ),
      },
      ...columns,
      {
        id: "ACTIONS",
        Header: "Actions",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center">
              <Tooltip
                title="order details"
                onClick={() => {
                  // console.log(row.id)
                  navigate("/order-details", {
                    state: {
                      data: row.original,
                    },
                  });
                }}
              >
                <IconButton>
                  <Info style={{ fontSize: "2rem", color: "#0a305e" }} />
                </IconButton>
              </Tooltip>
              <Tooltip
                title="order status"
                onClick={() => {
                  // console.log(row.id)
                  setOrder(row.original);
                  handleOpen();
                }}
              >
                <IconButton>
                  <MoreHoriz style={{ fontSize: "2rem", color: "#0a305e" }} />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
      },
    ]);
  };

  const tableInstance = useTable(
    { columns, data },
    useGlobalFilter,
    tableHooks,
    useSortBy
  );
  const handleSliderSelect = () => {
    setOrderStatus("");
    setOrder({});
    fetchOrdersList();
    handleClose();
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    preGlobalFilteredRows,
    setGlobalFilter,
    state,
  } = tableInstance;

  return (
    <>
     {loading ? (
        <Box sx={spinnerstyle}>
          <PuffLoader loading={loading} size={150} />
        </Box>
      ) : (
        <>
      <div className="flex justify-between w-[95%] m-auto mt-[5rem]">
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title2"
          aria-describedby="modal-modal-description2"
        >
          <Box sx={style}>
            <FormGroup>
              <InputLabel id="demo-simple-select-label">
                Order Status:
              </InputLabel>
              <Select
                id="demo-simple-select"
                value={order_status}
                style={{ textAlign: "left" }}
                onChange={(e) => {
                  setOrderStatus(e.target.value);
                  updateOrderStatus(
                    {
                      order_id: order.order_id,
                      order_status: e.target.value,
                    },
                    config,
                    handleSliderSelect
                  );
                }}
              >
                {statusList.map((stat) => {
                  return (
                    <MenuItem value={stat.value} key={stat.value}>
                      {stat.label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormGroup>
          </Box>
        </Modal>
        <GlobalFilter
          preGlobalFilteredRows={preGlobalFilteredRows}
          setGlobalFilter={setGlobalFilter}
          globalFilter={state.globalFilter}
        />
        <div className="w-[25%] flex flex-wrap">
          <div className="w-[100%] flex justify-between">
            <FormGroup>
              <InputLabel id="demo-simple-select-label">
                Order Status:
              </InputLabel>
              <Select
                id="demo-simple-select"
                value={filterStatus}
                style={{ textAlign: "left" }}
                onChange={(e) => {
                  setFilterStatus(e.target.value);
                  if (e.target.value === 'All') {
                    setFilteredList(ordersList);
                  } else {
                    setFilteredList(ordersList.filter((el) => el.order_status === e.target.value))
                  }
                }}
              >
                <MenuItem value={"All"} key={"All"}>
                  {" "}
                  All{" "}
                </MenuItem>
                {statusList.map((stat) => {
                  return (
                    <MenuItem value={stat.value} key={stat.value}>
                      {stat.label}
                    </MenuItem>
                  );
                })}
                {/* <MenuItem value={"Pending"} key={"Pending"} > All </MenuItem>
                  <MenuItem value={"ALl"} key={"ALl"} > All </MenuItem> */}
              </Select>
            </FormGroup>
          </div>
          {/* <Button
          variant="contained"
          fullWidth
          sx={{
            mt: "1rem",
          }}
          onClick={getDateWiseData}
        >
          Filter
        </Button> */}
        </div>
        {/* <Button
        type="button"
        variant="contained"
        // onClick={handleOpen}
        onClick={() => navigate('/add-product-sub-category')}
      >
        Add New
      </Button> */}
      </div>
      <table {...getTableProps()} className="w-[95%] m-auto mt-10">
        <thead>
          {
            // Loop over the header rows
            headerGroups.map((headerGroup) => (
              // Apply the header row props
              <tr {...headerGroup.getHeaderGroupProps()}>
                {
                  // Loop over the headers in each row
                  headerGroup.headers.map((column) => (
                    // Apply the header cell props
                    <th
                      {...column.getHeaderProps()}
                      className="border-4 p-3 bg-[#1976d2] text-white"
                    >
                      {
                        // Render the header
                        column.render("Header")
                      }
                    </th>
                  ))
                }
              </tr>
            ))
          }
        </thead>
        {/* Apply the table body props */}
        <tbody {...getTableBodyProps()}>
          {
            // Loop over the table rows
            rows.map((row, index) => {
              // Prepare the row for display
              prepareRow(row);
              return (
                // Apply the row props
                <tr {...row.getRowProps()}>
                  {
                    // Loop over the rows cells
                    row.cells.map((cell) => {
                      // Apply the cell props
                      return (
                        //  <td {...cell.getCellProps()} className={`p-5 border-1px bg-blue-300 cursor-pointer`}>
                        <td
                          {...cell.getCellProps()}
                          className={`p-5 border-1px bg-${
                            index % 2 === 0 ? "white" : "blue-300"
                          } cursor-pointer text-center`}
                          style={{
                            background: !row.original.is_active
                              ? "#b3b3b3"
                              : null,
                          }}
                        >
                          {
                            // Render the cell contents
                            cell.render("Cell")
                          }
                        </td>
                      );
                    })
                  }
                </tr>
              );
            })
          }
        </tbody>
      </table>
    </>)}</>
  );
};
